import Card from "components/Card/Card.jsx";
import Select from "react-select";
import Collapsible from "react-collapsible";
import Checkbox from "components/CustomCheckbox/CustomCheckbox.jsx";
import Button from "components/CustomButton/CustomButton.jsx";
import axios from "axios";
import { style } from "../../../variables/Variables";
import React, { Component } from "react";
import LoadingOrder from "views/Components/loadingOrder";
import LoadingMedication from "views/Components/loadingMedication";
import { extendMoment } from "moment-range";
import { bankData, branchData } from "utils/getBankNameAndBranch";
import originalMoment from "moment";
import Datetime from "react-datetime";
import {
  getAllOrganizationWiseLeads,
  CreateLeads,
  deleteLeads,
  getOrganizationDetails,
} from "Listfunction";
import SweetAlert from "react-bootstrap-sweetalert";
import DatePicker from "react-datepicker";
import {
  Col,
  FormControl,
  FormGroup,
  Grid,
  Row,
  Modal,
  ControlLabel,
  Table,
  OverlayTrigger,
  Pagination,
  Tooltip,
} from "react-bootstrap";
import "api/purchaseOrder/PurchaseOrder";
import LoadingSpinner from "views/Components/loadingSpinner";
import ScreenLoader from "views/Components/screenLoader";
import LoadingPdfSpinner from "views/Components/loadingPdfSpinner";
import Radio from "components/CustomRadio/CustomRadio.jsx";
const moment = extendMoment(originalMoment);

class userManagement extends Component {
  constructor(props) {
    super(props);
    const today = moment();
    this.state = {
      date_of_birth: "",
      openAddleadsmodal: false,
      mobileNumberError: null,
      leadsName: "",
      // remainingCredit: "",
      mobileNumber: "",
      gender: "",
      pcode: "+94",
      getAllOrganizationLeads: [],
      isLoading: false,
      leadsNameError: null,
      // remainingCreditError: null,
      _notificationSystem: null,
      alert: null,
      organizationValueError: null,
      organizationValue: "",
      organizationOption: [],
      isSubcompanyShow: false,
      accountName: "",
      accountNumber: "",
      reEnterAccountNumber: "",
      selectedBank: "",
      branches: [],
      selectedBranch: "",
      accountNumberError: null,
      email: "",
      reEnterAccountNumber: "",
      requiredAccountNumberError: null,
    };
    this.componentDidMount = this.componentDidMount.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.deleteLeadsDetails = this.deleteLeadsDetails.bind(this);
    this.SelectLeadsToDelete = this.SelectLeadsToDelete.bind(this);
    this.editLeads = this.editLeads.bind(this);
    this.hideAlert = this.hideAlert.bind(this);
    this.handleDateChange = this.handleDateChange.bind(this);
  }

  componentDidMount() {
    this.setState({ _notificationSystem: this.refs.notificationSystem });
    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;
    this.getAllLeads();
  }

  onChange = (event) => {
    const target = event.target;
    const value = target.type === "select" ? target.selected : target.value;
    const name = target.name;

    this.setState({
      [name]: value,
    });
  };
  SelectLeadsToDelete = (id) => {
    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;
    deleteLeads(id, obj)
      .then((res) => {
        this.setState({
          alert: null,
        });
        this.getAllLeads();
      })
      .catch((error) => {});
  };
  deleteLeadsDetails(id) {
    this.setState({
      alert: (
        <SweetAlert
          warning
          style={{ display: "block", marginTop: "-100px" }}
          title="Are you sure?"
          onConfirm={() => this.SelectLeadsToDelete(id)}
          onCancel={() => this.hideAlert()}
          confirmBtnBsStyle="info"
          cancelBtnBsStyle="danger"
          confirmBtnText="Yes, delete it!"
          cancelBtnText="Cancel"
          showCancel
        >
          You will not be able to recover this Lead Detail !
        </SweetAlert>
      ),
    });
  }

  closeModal = () => {
    this.setState({
      openAddleadsmodal: false,
      mobileNumber: "",
      leadsName: "",
      accountName: "",
      accountNumber: "",
      gender: "",
      pcode: "+94",
      leadsNameError: null,
      // remainingCreditError: null,
      mobileNumberError: null,
      date_of_birth: "",
      organizationValueError: null,
      organizationValue: "",
      accountNumberError: null,
      email: "",
      reEnterAccountNumber: "",
      accountNumber: "",
      requiredAccountNumberError: null,
      selectedBank:"",
      selectedBranch:"",
    });
  };
  handleDateChange = (date) => {
    this.setState({
      date_of_birth: date,
    });
  };

  getAllLeads = () => {
    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;
    getAllOrganizationWiseLeads(obj)
      .then((res) => {
        const getAllOrganizationLeads = res.data.data;
        this.setState({ getAllOrganizationLeads });
      })
      .catch(() => {});
  };
  selectOrganizationValue = () => {
    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;

    getOrganizationDetails(obj)
      .then((res) => {
        const selectOrganization = res.data || [];
        if (selectOrganization.length > 0) {
          this.setState({ isSubcompanyShow: true });
        }

        const organizationValueOptions = selectOrganization.map((data) => ({
          value: data.id,
          label: data.company_name,
        }));

        const organizationValue = [
          { value: "", label: "Select organization" },
          ...organizationValueOptions,
        ];

        this.setState({ organizationOption: organizationValue });
      })
      .catch((err) => {
        console.error("Error fetching organization details:", err);
      });
  };
  selectOrganizationValueHandler = (value) => {
    this.setState({
      organizationValue: value,
      organizationValueError: value ? null : "Please select an organization",
    });
  };

  editLeads(x) {
    localStorage.setItem("id", JSON.stringify(x));

    this.setState({ openAddleadsmodal: true });
  }

  onSubmit() {
    this.setState({ errormessages: [] });
    let error = false;

    if (this.state.leadsName == "" || this.state.leadsName == null) {
      error = true;
      this.setState({
        leadsNameError: (
          <small className="text-danger" style={{ padding: "3px" }}>
            Lead Name is required.
          </small>
        ),
      });
    } else {
      this.setState({ leadsNameError: null });
    }
    // if (
    //   this.state.remainingCredit == "" ||
    //   this.state.remainingCredit == null
    // ) {
    //   error = true;
    //   this.setState({
    //     remainingCreditError: (
    //       <small className="text-danger" style={{ padding: "3px" }}>
    //         Remaining Credit is required.
    //       </small>
    //     ),
    //   });
    // } else {
    //   this.setState({ remainingCreditError: null });
    // }
    if (this.state.mobileNumber == "" || this.state.mobileNumber == null) {
      error = true;
      this.setState({
        mobileNumberError: (
          <small className="text-danger" style={{ padding: "3px" }}>
            Mobile number is required.
          </small>
        ),
      });
    } else {
      this.setState({ mobileNumberError: null });
    }
    if (
      (this.state.organizationValue == "" ||
        this.state.organizationValue == null) &&
      this.state.isSubcompanyShow
    ) {
      error = true;
      this.setState({
        organizationValueError: (
          <small className="text-danger" style={{ padding: "3px" }}>
            Orgnaization is required.
          </small>
        ),
      });
    } else {
      this.setState({ organizationValueError: null });
    }
    if (
      this.state.accountName !== "" &&
      this.state.accountName !== null &&
      (this.state.reEnterAccountNumber === "" ||
        this.state.reEnterAccountNumber === null ||
        this.state.selectedBank === "" ||
        this.state.selectedBank === null ||
        this.state.selectedBranch === "" ||
        this.state.selectedBranch === null)
    ) {
      error = true;
      this.setState({
        requiredAccountNumberError: (
          <small className="text-danger" style={{ padding: "3px" }}>
            Field required.
          </small>
        ),
      });
    } else {
      this.setState({ requiredAccountNumberError: null });
    }
    if (!error) {
      var token = JSON.parse(localStorage.getItem("user"));
      const obj = token.token;

      CreateLeads(
        obj,
        this.state.leadsName,
        this.state.pcode + this.state.mobileNumber,
        // this.state.remainingCredit,
        this.state.date_of_birth,
        this.state.organizationValue.value,
        this.state.accountName,
        this.state.selectedBank,
        this.state.selectedBranch,
        this.state.reEnterAccountNumber,
        this.state.email
      )
        .then(() => {
          this.setState({
            openAddleadsmodal: false,
            sendAddLeadsData: [],
            leadsName: "",
            mobileNumber: "",
            // remainingCredit: "",
            date_of_birth: "",
            processing: false,
            isLoading: false,
            date_of_birth: "",
            organizationValue: "",
            accountName: "",
            accountNumber: "",
            organizationValue: "",
            email: "",
            reEnterAccountNumber: "",
            accountNumber: "",
            accountNumberError: null,
            requiredAccountNumberError: null,
            selectedBank:"",
            selectedBranch:"",
          });
          this.getAllLeads();
        })
        .catch((error) => {
          error = true;
          this.setState({
            alert: (
              <SweetAlert
                warning
                style={{ display: "block", marginTop: "-100px" }}
                title="Please change your mobile number"
                onConfirm={() => this.hideAlert()}
                confirmBtnBsStyle="info"
                // cancelBtnBsStyle="danger"
                // cancelBtnText="Ok"
                // showCancel
              >
                Lead already exists
              </SweetAlert>
            ),
          });
          this.setState({
            processing: false,
            isLoading: false,
          });
        });
    }
  }
  hideAlert() {
    this.setState({ alert: null });
  }
  handleBankChange = (event) => {
    const selectedBank = event.target.value;
    const branches = branchData()[selectedBank] || [];
    this.setState({
      selectedBank,
      branches,
      selectedBranch: "",
    });
  };

  handleBranchChange = (event) => {
    const selectedBranch = event.target.value;
    this.setState({ selectedBranch }, () => {
    });
  };
  handleAccountNumberChange = (event) => {
    this.setState(
      { accountNumber: event.target.value },
      this.validateAccountNumbers
    );
  };

  handleReEnterAccountNumberChange = (event) => {
    this.setState(
      { reEnterAccountNumber: event.target.value },
      this.validateAccountNumbers
    );
  };

  validateAccountNumbers = () => {
    const { accountNumber, reEnterAccountNumber } = this.state;
    if (reEnterAccountNumber && accountNumber !== reEnterAccountNumber) {
      this.setState({ accountNumberError: "Account numbers do not match!" });
    } else {
      this.setState({ accountNumberError: "" });
    }
  };

  render() {
    const remove = <Tooltip id="remove">Remove</Tooltip>;
    const edit = <Tooltip id="edit">Edit</Tooltip>;
    const errormessages = this.state.errormessages;
    const { selectedBank, branches, selectedBranch } = this.state;

    return (
      <div className="main-content">
        {this.state.pdfloading ? <LoadingPdfSpinner /> : ""}
        <Grid fluid>
          {this.state.alert}
          <Card
            content={
              <Row>
                <Col
                  xs={12}
                  sm={12}
                  md={12}
                  lg={12}
                  style={{ marginBottom: "40px" }}
                >
                  <Row>
                    <Col xs={2} sm={2} md={2} lg={2} className="text-left">
                      <Button
                        style={{ marginTop: "25px" }}
                        className="fl_mb_web_1 fl_mb_1 w_150 btn-color"
                        onClick={() => {
                          this.setState({ openAddleadsmodal: true });
                            this.selectOrganizationValue();
                        }}
                      >
                        <i className="fa fa-users" style={{ color: "red" }}></i>{" "}
                        ADD Leads
                      </Button>
                      &nbsp;
                    </Col>
                  </Row>
                </Col>
                <Col md={12} sm={12} lg={12} xs={12}>
                  <Table responsive className="order_list_table_show">
                    <thead>
                      <tr>
                        <th>Name</th>
                        <th>Mobile Number</th>
                        <th>email</th>
                        <th>Earn Points</th>
                        <th>Updated at</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {this.state.loading ? (
                        <tr>
                          <td colSpan="10">
                            <LoadingSpinner />
                          </td>
                        </tr>
                      ) : this.state.noRecordFound ? (
                        <tr>
                          <td colSpan="10">
                            <center>No record found</center>
                          </td>
                        </tr>
                      ) : (
                        <React.Fragment>
                          {this.state.getAllOrganizationLeads.map((x) => (
                            <tr>
                              <td>{x.name}</td>
                              <td>{x.mobile_no}</td>
                              <td>{x.email}</td>
                              <td>{x.earn_points}</td>
                              <td>{x.updated_at}</td>
                              <td>
                                <OverlayTrigger
                                  placement="top"
                                  overlay={remove}
                                >
                                  <Button
                                    simple
                                    bsStyle="danger"
                                    onClick={this.deleteLeadsDetails.bind(
                                      this,
                                      x.id
                                    )}
                                    bsSize="xs"
                                  >
                                    <i className="fa fa-times" />
                                  </Button>
                                </OverlayTrigger>
                                <OverlayTrigger placement="top" overlay={edit}>
                                  <Button
                                    simple
                                    bsStyle="success"
                                    onClick={this.editLeads.bind(this, x.id)}
                                    bsSize="xs"
                                  >
                                    <i className="fa fa-pencil" />
                                  </Button>
                                </OverlayTrigger>
                              </td>
                            </tr>
                          ))}
                        </React.Fragment>
                      )}
                    </tbody>
                  </Table>
                </Col>
              </Row>
            }
          />
        </Grid>
        {this.state.isLoading ? <ScreenLoader /> : ""}

        <Modal
          show={this.state.openAddleadsmodal}
          onHide={() => this.setState({ openAddleadsmodal: false })}
          bsSize="lg"
        >
          <Modal.Header>
            <Modal.Title>Add Leads</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Row>
              <Col xs={12}>
                {!!this.state.isSubcompanyShow && (
                  <FormGroup>
                    <ControlLabel>Select Package</ControlLabel>
                    <Select
                      name="organizationValue"
                      value={this.state.organizationValue}
                      placeholder="Enter the Package"
                      onChange={(value) =>
                        this.selectOrganizationValueHandler(value)
                      }
                      options={this.state.organizationOption}
                    />
                    {this.state.organizationValueError}
                  </FormGroup>
                )}
                <FormGroup>
                  <ControlLabel>Leads Name</ControlLabel>
                  <FormControl
                    name="leadsName"
                    value={this.state.leadsName}
                    onChange={(event) => {
                      this.setState({
                        leadsName: event.target.value,
                      });
                    }}
                    placeholder="Enter User Name"
                    type="text"
                  />
                  {this.state.leadsName == ""
                    ? this.state.leadsNameError
                    : null}
                </FormGroup>
                <FormGroup>
                  {/* <FormGroup>
                    <ControlLabel>Claim Value</ControlLabel>
                    <FormControl
                      name="remainingCredit"
                      value={this.state.remainingCredit}
                      onChange={(event) => {
                        const value = event.target.value;
                        if (value > 100000) {
                          this.setState({
                            remainingCreditError: (
                              <small
                                className="text-danger"
                                style={{ padding: "3px" }}
                              >
                                Remaining Credit can enter a max value of
                                100000.
                              </small>
                            ),
                          });
                        } else if (value < 0) {
                          this.setState({
                            remainingCreditError: (
                              <small
                                className="text-danger"
                                style={{ padding: "3px" }}
                              >
                                Remaining Credit must be at least 1.
                              </small>
                            ),
                          });
                        } else {
                          this.setState({
                            remainingCredit: value,
                            remainingCreditError: null,
                          });
                        }
                      }}
                      placeholder="Claim Value"
                      type="number"
                    />
                    {this.state.remainingCreditError}
                  </FormGroup> */}
                  <ControlLabel>Phone No</ControlLabel>
                  <Col xs={12}>
                    <Col
                      md={2}
                      className="no-padding"
                      style={{ marginTop: "4px" }}
                    >
                      <select
                        onChange={this.onChange}
                        name="pcode"
                        value={this.state.pcode}
                        className="form-control"
                      >
                        <option value="+94">+94</option>
                        <option value="+91">+91</option>
                      </select>
                    </Col>
                    <Col md={10}>
                      <FormControl
                        type="number"
                        required
                        name="mobileNumber"
                        onChange={(event) => {
                          const value = event.target.value;
                          if (value.length > 9) {
                            this.setState({
                              mobileNumberError: (
                                <small
                                  className="text-danger"
                                  style={{ padding: "3px" }}
                                >
                                  Mobile number must be exactly 9 digits.
                                </small>
                              ),
                            });
                          } else {
                            this.setState({
                              mobileNumber: value,
                              mobileNumberError: null,
                            });
                          }
                        }}
                        value={this.state.mobileNumber || ""}
                        placeholder="Enter Mobile Number"
                      />
                      {this.state.mobileNumberError}
                    </Col>
                  </Col>
                </FormGroup>
                <br />
                <FormGroup>
                  <ControlLabel>Email</ControlLabel>
                  <FormControl
                    name="Email"
                    value={this.state.email}
                    onChange={(event) => {
                      this.setState({
                        email: event.target.value,
                      });
                    }}
                    placeholder="Enter Email"
                    type="text"
                  />
                </FormGroup>
                <br />
                <ControlLabel>Gender</ControlLabel>
                <div className="order_source_data">
                  <Radio
                    number="1"
                    option="male"
                    name="gender"
                    onChange={this.onChange}
                    checked={this.state.gender === "male"}
                    label="Male"
                  />
                  &nbsp;
                  <Radio
                    number="2"
                    option="female"
                    name="gender"
                    onChange={this.onChange}
                    checked={this.state.gender === "female"}
                    label="Female"
                  />
                  <Radio
                    number="3"
                    option="other"
                    name="gender"
                    onChange={this.onChange}
                    checked={this.state.gender === "other"}
                    label="Other"
                  />
                </div>
                <FormGroup>
                  <ControlLabel>Date of Birth</ControlLabel>
                  <br />
                  <Datetime
                    timeFormat={false}
                    dateFormat="YYYY-MM-DD"
                    inputProps={{ placeholder: "Order Date" }}
                    closeOnSelect={true}
                    value={this.state.date_of_birth}
                    onChange={this.handleDateChange}
                  />
                  {this.state.dateOfBirthError}
                </FormGroup>
              </Col>
            </Row>
            <Col md={12} className="bankDetailsShowing">
              <Collapsible
                trigger={
                  <span>
                    <i
                      className="fa fa-plus-circle"
                      aria-hidden="true"
                      style={{ marginRight: "8px" }}
                    ></i>
                    Add Bank Details
                  </span>
                }
                transitionTime={200}
              >
                <br />
                <div style={{ display: "flex", width: "100%", gap: "30px" }}>
                  <FormGroup style={{ width: "48%" }}>
                    <ControlLabel>Bank Name</ControlLabel>
                    <select
                      className="form-control"
                      value={selectedBank}
                      onChange={this.handleBankChange}
                    >
                      <option value="" disabled>
                        Select Bank Name
                      </option>
                      {bankData().map((bank, index) => (
                        <option key={index} value={bank}>
                          {bank}
                        </option>
                      ))}
                    </select>
                    {this.state.selectedBank == ""
                      ? this.state.requiredAccountNumberError
                      : null}
                  </FormGroup>
                  {/* {branches.length > 0 && (  */}
                  <FormGroup style={{ width: "48%" }}>
                    <ControlLabel>Bank Branch</ControlLabel>
                    <select
                      className="form-control"
                      value={selectedBranch}
                      onChange={this.handleBranchChange}
                      disabled={!selectedBank}
                    >
                      <option value="">Select Branch</option>
                      {branches.map((branch, index) => (
                        <option key={index} value={branch}>
                          {branch}
                        </option>
                      ))}
                    </select>
                    {this.state.selectedBranch == ""
                      ? this.state.requiredAccountNumberError
                      : null}
                  </FormGroup>
                  {/* )} */}
                </div>
                <div style={{ display: "flex", width: "100%", gap: "30px" }}>
                  <FormGroup style={{ width: "48%" }}>
                    <ControlLabel>Account Name</ControlLabel>
                    <FormControl
                      name="accountName"
                      value={this.state.accountName}
                      onChange={(event) => {
                        this.setState({
                          accountName: event.target.value,
                        });
                      }}
                      placeholder="Enter Account Name"
                      type="text"
                    />
                  </FormGroup>
                  <FormGroup style={{ width: "47%" }}>
                    <ControlLabel>Account Number</ControlLabel>
                    <FormControl
                      name="accountNumber"
                      value={this.state.accountNumber}
                      onChange={this.handleAccountNumberChange}
                      placeholder="Account Number"
                      type="text"
                    />
                    {this.state.accountNumber == ""
                      ? this.state.requiredAccountNumberError
                      : null}
                  </FormGroup>
                </div>
                <div style={{ display: "flex", width: "100%", gap: "30px" }}>
                  <FormGroup style={{ width: "48%" }}>
                    <ControlLabel>Re-Enter Account Number</ControlLabel>
                    <FormControl
                      placeholder="Re-Enter Account Number"
                      value={this.state.reEnterAccountNumber}
                      onChange={this.handleReEnterAccountNumberChange}
                      type="text"
                    />
                    {this.state.accountNumberError && (
                      <span
                        style={{
                          color: "red",
                          marginTop: "10px",
                          paddingLeft: "10px",
                          fontSize: "12px",
                        }}
                      >
                        {this.state.accountNumberError}{" "}
                        {this.state.reEnterAccountNumber == ""
                          ? this.state.requiredAccountNumberError
                          : null}
                      </span>
                    )}
                  </FormGroup>
                </div>
              </Collapsible>
            </Col>
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={this.onSubmit.bind(this)} bsStyle="success" fill>
              Submit
            </Button>
            <Button bsStyle="danger" fill onClick={this.closeModal}>
              Cancel
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}
export default userManagement;
